import request from '@/CommonDP/utils/request';
export default {
  // 消息模块
  messageList(params) {
    return request.post('/message/list', params);
  },
  messageRead(params) {
    return request.post('/message/read', params);
  },
  messageDelete(params) {
    return request.post('/message/delete', params);
  },
  // 未读消息/未阅消息
  getUnReadNum(enterpriseId) {
    return request.get(
      `/message/getMessageNum?enterpriseId=${enterpriseId}`
    );
  },
  // 问题消息是否删除
  drawingAnnotation(id) {
    return request.get(`/drawing-annotation/getById?id=${id}`);
  },

  // 计划消息是否删除
  prjqueryTaskNew(id) {
    return request.get(`/prj-plan-task/queryTask?taskId=${id}`);
  },
  // 消息数量
  unreadlist(enterpriseId) {
    return request.get(
      `/message/unread/list?enterpriseId=${enterpriseId}`
    );
  }
};
